import React from 'react';

import { margin, separator } from './separator.module.scss';

const Separator = ({ className = '', withMargin = false }) => (
    <span className={`${separator} ${className} ${withMargin ? margin : ''}`} />
);

export default Separator;
